import { useCallback, useEffect, useState } from "react";
import { getIOSInstallBrowser } from "../utils/deviceInstall";

export function usePWAInstallPrompt() {
	const [deferredPrompt, setDeferredPrompt] = useState(null);
	const [isInstallable, setIsInstallable] = useState(false);
	const [isInstalled, setIsInstalled] = useState(false);
	const { isIOS, browser: iosBrowser } = getIOSInstallBrowser();

	useEffect(() => {
		const isStandalone =
			window.matchMedia("(display-mode: standalone)").matches ||
			window.navigator.standalone === true;

		if (isStandalone) {
			setIsInstalled(true);
		}

		const handleBeforeInstallPrompt = (event) => {
			event.preventDefault();
			setDeferredPrompt(event);
			setIsInstallable(true);
		};

		const handleAppInstalled = () => {
			setDeferredPrompt(null);
			setIsInstallable(false);
			setIsInstalled(true);
		};

		window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
		window.addEventListener("appinstalled", handleAppInstalled);

		return () => {
			window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
			window.removeEventListener("appinstalled", handleAppInstalled);
		};
	}, []);

	const promptInstall = useCallback(async () => {
		if (!deferredPrompt) {
			return { outcome: null, error: "No install prompt available" };
		}

		await deferredPrompt.prompt();
		const choiceResult = await deferredPrompt.userChoice;

		setDeferredPrompt(null);
		setIsInstallable(false);

		return choiceResult;
	}, [deferredPrompt]);

	return {
		isInstallable,
		isInstalled,
		isIOS,
		iosBrowser,
		requiresManualInstall: isIOS && !isInstalled && !isInstallable,
		promptInstall,
	};
}